var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCirclesMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 359 247",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328.004 114.73C318.694 67.836 273.133 37.368 226.239 46.6775C179.345 55.987 148.877 101.549 158.187 148.442C167.496 195.336 213.058 225.804 259.952 216.494C306.845 207.185 337.313 161.623 328.004 114.73Z",
    stroke: "url(#paint0_linear_77_10963)",
    strokeWidth: 22.5282
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.004 114.73C318.694 67.836 273.133 37.368 226.239 46.6775C179.345 55.987 148.877 101.549 158.187 148.442C167.496 195.336 213.058 225.804 259.952 216.494C306.845 207.185 337.313 161.623 328.004 114.73Z",
    stroke: "url(#paint1_linear_77_10963)",
    strokeWidth: 22.5282
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 104C12 53.1899 53.1898 12.0001 104 12.0001C154.81 12.0001 196 53.1898 196 104C196 154.81 154.81 196 104 196C53.1898 196 12 154.81 12 104Z",
    stroke: "url(#paint2_linear_77_10963)",
    strokeWidth: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 104C12 53.1899 53.1898 12.0001 104 12.0001C154.81 12.0001 196 53.1898 196 104C196 154.81 154.81 196 104 196C53.1898 196 12 154.81 12 104Z",
    stroke: "url(#paint3_linear_77_10963)",
    strokeWidth: 24
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_77_10963",
    x1: 262.145,
    y1: 227.543,
    x2: 224.046,
    y2: 35.629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.552083,
    stopColor: "#A6C8FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.880208,
    stopColor: "#0464FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_77_10963",
    x1: 262.145,
    y1: 227.543,
    x2: 224.046,
    y2: 35.629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.552083,
    stopColor: "#A6C8FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.880208,
    stopColor: "#0464FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_77_10963",
    x1: 104,
    y1: 208,
    x2: 104,
    y2: 0.0000548683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.552083,
    stopColor: "#A6C8FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.880208,
    stopColor: "#0464FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_77_10963",
    x1: 104,
    y1: 208,
    x2: 104,
    y2: 0.0000548683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.552083,
    stopColor: "#A6C8FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.880208,
    stopColor: "#0464FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclesMobile);
export default __webpack_public_path__ + "static/media/circles-mobile.b77c0ff14e45e58184b55b0680ea57a2.svg";
export { ForwardRef as ReactComponent };